import React from "react";
import { useEndOfServiceLogic } from "./useEndOfServiceLogic";

const EndOfService = () => {
  useEndOfServiceLogic();
  return null;
};

export default EndOfService;
